import React from 'react';
import CategoryGroup from './category/category-group/CategoryGroup';
import { CATEGORY_TYPES, LINK_TYPE_CATEGORIES } from './constants';

import c from './categories.module.scss';

const Categories = ({ categories }) => {
  return (
    <section aria-label="Categories" className={c.categories}>
      {CATEGORY_TYPES.map((type) => (
        <CategoryGroup
          key={type}
          type={type}
          categories={categories.filter((category) => category.type === type)}
        />
      ))}

      <CategoryGroup key="type" type="type" categories={LINK_TYPE_CATEGORIES} />
    </section>
  );
};

export default Categories;
